import Al from "./Al";
import At from "./At";
import Ch from "./Ch";
import De from "./De";
import En from "./En";
import Es from "./Es";
import Fr from "./Fr";
import Gb from "./Gb";
import It from "./It";
import Us from "./Us";
import Flags from "./Flags";

export { Al, At, Ch, De, En, Es, Fr, Gb, It, Us };

export default Flags;
